import { Injectable } from '@angular/core';
import { ResourceRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResourceStateService {
  valueOf<T>(resource: ResourceRef<T | undefined>): T | undefined {
    return resource.hasValue() ? resource.value() : undefined;
  }
}
